<template>
  <section class="section">
    <nav class="level">
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Total products</p>
          <router-link to="/products">
            <p class="subtitle is-4 has-text-primary">{{ this.$store.state.productsTotal | numberDisplay }}</p>
          </router-link>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Total applications</p>
          <router-link to="/clients">
            <p class="subtitle is-4 has-text-primary">{{ this.$store.state.clientsTotal | numberDisplay }}</p>
          </router-link>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Total users</p>
          <router-link to="/users">
            <p class="subtitle is-4 has-text-primary">{{ this.$store.state.usersTotal | numberDisplay }}</p>
          </router-link>
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
  export default {
    methods: {
      getTotals () {
        this.$store.dispatch('getOrganizationProducts', {
          organizationId: this.$store.state.organizationId,
          params: { limit: 1 }
        })

        this.$store.dispatch('getOrganizationClients', {
          organizationId: this.$store.state.organizationId,
          params: { limit: 1 }
        })

        this.$store.dispatch('getOrganizationUsers', {
          organizationId: this.$store.state.organizationId,
          params: { limit: 1 }
        })
      }
    },

    created () {
      if (this.$store.state.organizationId) {
        this.getTotals()
      }
    },

    watch: {
      '$store.state.organizationId' () {
        this.getTotals()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?3901efb9